import React,{Fragment} from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

import Spacer from "./spacer"

const Footer = ({removeFooterTopPadding}) => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      footer:datoCmsFooter {
        documentationTwo {
          title
          links {
            title
            link
          }
        }
        documentation {
          title
          links {
            title
            link
           
          }
        }
      }
    }
  `)
  const {footer} = data;
  return (
  <footer className={`colophon p20 ${removeFooterTopPadding ? 'pt0':''}`}>
    <Spacer className='bt1 ml20 mr20 m-m0' />
    <div className='ml20 mr20 m-m0 flex m-wrap m-col-reverse'>
      <div className='w-50 m-100 m-mt20'>
        <Link to='/'><div className='logo--footer'/></Link>
        <p className='m0 op-50 mt40 small'>© {new Date().getFullYear()}, ARCTURUS STUDIOS HOLDINGS, INC. ALL RIGHTS RESERVED.</p>
        <div className='mt40 flex'>
          <a href='https://twitter.com/ArcturusXR' aria-label='twitter'  target='_blank' rel='noreferrer' className='link op-link op-50'><div className='icon x'/></a>
          <a href='https://www.linkedin.com/company/arcturusxr' aria-label='linkedin' target='_blank' rel='noreferrer' className='link op-link op-50'><div className='icon linkedin'/></a>
          <a href='https://www.youtube.com/channel/UCkUlXTb3gI5ckvsyjAc7r6Q' aria-label='youtube' target='_blank' rel='noreferrer' className='link op-link op-50'><div className='icon youtube'/></a>
          <a href='https://www.facebook.com/arcturusXR' aria-label='facebook' target='_blank' rel='noreferrer' className='link op-link op-50'><div className='icon facebook'/></a>
        </div> 
        <div className='lh2 small mt30'>
          <a className='link op-link mr20' href='https://static.arcturus.studio/CopyrightInfringement.html'>Copyright Notice</a>
          <a className='link op-link mr20' href='https://static.arcturus.studio/PrivacyPolicyStatements.html' target='_blank' rel='noreferrer'>Privacy Policy</a>
          <a className='link op-link mr20' download href='https://www.datocms-assets.com/104353/1731095933-june-5-2023-arcturus-general-terms-of-use-v2-docx.pdf' target='_blank' rel='noreferrer'>General Terms Of Use</a>
          <a className='link op-link mr20' download href='https://www.datocms-assets.com/104353/1731095933-june-5-2023-player-distribution-license-v2-docx.pdf' target='_blank' rel='noreferrer'>Player Distribution License</a><br className='m-hide'/>
          <a className='link op-link mr20' download href='https://www.datocms-assets.com/104353/1731095933-june-5-2023-player-end-user-license-agreement-v2-docx.pdf' target='_blank' rel='noreferrer'>Player End User License Agreement</a>
          <a className='link op-link mr20' download href='https://www.datocms-assets.com/104353/1694523924-additional-software-terms.pdf' target='_blank' rel='noreferrer'>Additional Software Terms</a>
          <a className='link op-link mr20' download href='https://www.datocms-assets.com/104353/1698904597-holosuite-third-party-software-credits-and-attributions-2.pdf' target='_blank' rel='noreferrer'>Third Party Software</a>
        </div>
      </div>
      <div className='w-50 m-100 mt15'>
        <div className='max-650 ma m-mb40'>
          <div className='flex m-wrap'>
            <div className='w-50 m-100'>
              {footer.documentation?.map((documentation, index) => <Documentation documentation={documentation} key={index} />)}
            </div>
            <div className='w-50 m-100'>
              {footer.documentationTwo?.map((documentation, index) => <Documentation documentation={documentation} key={index} /> )} 
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spacer />
  </footer>  
  )
}
export default Footer

const Documentation = ({ documentation }) =>  (
  <div className='documentation mb20'>
    <p className='m0 mb20 op-75 bold'>{documentation.title}</p>
    {documentation.links?.map((link, index) => <Fragment key={index}><a  className='link grey inline mb5 op-link' target='_blank' rel='noreferrer' href={link?.link}>{link.title}</a><br/></Fragment>)}
  </div>
)

